import { CSSProperties } from 'react';
import MuiTooltip from '@mui/material/Tooltip';

import { ReactComponent as InfoIcon } from 'assets/@efz/icons/info-tooltip.svg';

import { StyledTooltipIcon } from 'components/@efz/Tooltip/StylesTooltip';
import IntlMessages from 'components/util/IntlMessages';

//TODO: TO BE REMOVED
type ITooltip = {
    children?: React.ReactElement<any>;
    title: React.ReactElement<any> | number | string;
    type?: 'info' | 'error' | 'warning' | 'default' | 'success';
    placement?:
        | 'top'
        | 'bottom-end'
        | 'bottom-start'
        | 'bottom'
        | 'left-end'
        | 'left-start'
        | 'left'
        | 'right-end'
        | 'right-start'
        | 'right'
        | 'top-end'
        | 'top-start'
        | undefined;
    defaultStyle?: CSSProperties;
    style?: CSSProperties;
    className?: string;
    iconClassName?: string;
    arrowPlacement?:
        | 'default'
        | 'bottom-end'
        | 'bottom-start'
        | 'left-end'
        | 'left-start'
        | 'right-end'
        | 'right-start'
        | 'top-end'
        | 'top-start'
        | 'none';
    enterDelay?: number;
    leaveDelay?: number;
    disableHoverListener?: boolean;
    open?: boolean | undefined; // This prop can be used for controlled behavior
    disablePortal?: boolean;
    leaveTouchDelay?: number;
    // Add a prop to explicitly enable interactive behavior
    isInteractive?: boolean;
};

const tooltipDefaultPropStyle = {};

const Tooltip: React.FC<ITooltip> = ({
    title = <IntlMessages id="efz.title.loremIpsum" />,
    children,
    type = 'info',
    placement = 'top',
    defaultStyle = Object.freeze({
        maxWidth: '210px',
    }),
    style = tooltipDefaultPropStyle,
    className = '',
    iconClassName = '',
    arrowPlacement = 'default',
    enterDelay,
    leaveDelay, // Keep leaveDelay, but we might adjust its value
    disableHoverListener,
    open = undefined,
    disablePortal,
    leaveTouchDelay,
    isInteractive = true, // New prop for explicit interactivity
}) => {
    return (
        <MuiTooltip
            disableHoverListener={disableHoverListener}
            placement={placement}
            title={<div className="efz-tooltip-content">{title}</div>}
            enterTouchDelay={0}
            enterDelay={enterDelay ?? undefined}
            leaveTouchDelay={leaveTouchDelay ?? undefined}
            leaveDelay={leaveDelay ?? undefined} // Ensure leaveDelay is passed
            arrow={arrowPlacement !== 'none' ? true : false}
            open={open ?? undefined}
            // The key for interactivity in v5/v6 often lies with the PopperProps
            // We ensure pointer events are allowed on the popper itself.
            PopperProps={{
                // disablePortal: disablePortal, // This is already in slotProps.popper, but PopperProps takes precedence for some props
                // Apply the interactive class and ensure pointer-events: auto
                sx: {
                    pointerEvents: isInteractive ? 'auto' : undefined,
                },
                modifiers: [
                    {
                        name: 'preventOverflow',
                        options: {
                            boundary: 'clippingParents',
                        },
                    },
                ],
            }}
            slotProps={{
                popper: {
                    sx: { pointerEvents: 'auto' },
                    disablePortal, // Use this for portal control
                    className: `efz-tooltip MuiTooltip-popper MuiTooltip-popperArrow efz-tooltip-${type} ${className} efz-tooltip-arrow-${arrowPlacement}`,
                    style: {
                        ...defaultStyle,
                        ...style,
                    },
                },
            }}
            className={className}
        >
            {/* The span wrapper is crucial for disabled children and for consistent hover behavior */}
            <span>
                {children ?
                    children
                :   <StyledTooltipIcon
                        $type={type}
                        size={'small'}
                        className={`efz-tooltip-icon-${type ? type : 'info'} ${iconClassName}`}
                        disableFocusRipple
                        disableRipple
                    >
                        <InfoIcon width={12} height={12} />
                    </StyledTooltipIcon>
                }
            </span>
        </MuiTooltip>
    );
};

export default Tooltip;
